import script from "./Terms-and-conditions.vue?vue&type=script&setup=true&lang=js"
export * from "./Terms-and-conditions.vue?vue&type=script&setup=true&lang=js"

import "./Terms-and-conditions.vue?vue&type=style&index=0&id=123ac84c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123ac84c"]])

export default __exports__